export default "__VITE_ASSET__fCHeaIp8__"